export default function SupportSettings() {
  return <div>Support & News</div>;
} 